<div class="flex px-32 justify-center items-center">
  <div class="flex justify-center items-center">
    <!--      TODO mudar badge de 1 para icone checked quando submeter form -->
    <div
      [ngClass]="{'rounded-full text-white w-8 h-8 flex items-center justify-center mr-2': true, 'bg-[var(--primary-color)]': activeStep() >= 0, 'bg-gray-300 text-gray-700': activeStep() < 0}">
      1
    </div>
    <div
      [ngClass]="{'text-sm font-medium': true, 'text-[--text-color]': true, 'text-[var(--primary-color)]': activeStep() >= 0, 'text-gray-700': activeStep() < 0}">
      Local de Solicitação
    </div>
  </div>
  <hr
    [ngClass]="{'mx-2': true, 'border-[var(--primary-color)]': activeStep() >= 1, 'border-gray-300': activeStep() < 1}"
    class="flex-grow border-t-2"/>
  <div class="flex items-center">
    <div
      [ngClass]="{'rounded-full text-white w-8 h-8 flex items-center justify-center mr-2': true, 'bg-[var(--primary-color)]': activeStep() >= 1, 'bg-gray-300 text-gray-700': activeStep() < 1}">
      2
    </div>
    <div
      [ngClass]="{'text-sm font-medium': true, 'text-[--text-color]': true, 'text-[var(--primary-color)]': activeStep() >= 1, 'text-gray-700': activeStep() < 1}">
      Descrição da Solicitação
    </div>
  </div>
  <hr
    [ngClass]="{'mx-2': true, 'border-[var(--primary-color)]': activeStep() >= 2, 'border-gray-300': activeStep() < 2}"
    class="flex-grow border-t-2">
  <div class="flex items-center">
    <div
      [ngClass]="{'rounded-full text-white w-8 h-8 flex items-center justify-center mr-2': true, 'bg-[var(--primary-color)]': activeStep() >= 2, 'bg-gray-300 text-gray-700': activeStep() < 2}">
      3
    </div>
    <div
      [ngClass]="{'text-sm font-medium': true, 'text-[--text-color]': true, 'text-[var(--primary-color)]': activeStep() >= 2, 'text-gray-700': activeStep() < 2}">
      Anexar Arquivos
    </div>
  </div>
</div>
